import React, { useEffect, useState } from "react";
import axios from "axios";
import BuyerDashboard from "./Buyer/BuyerDashboard.jsx";
import PurchaseHeadDashboard from "./Purchase Head/PurchaseHeadDashboard.jsx";
import CXODashboard from "./CXO/CXODashboard.jsx";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [user, setUser] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    const getOrgUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setUser(res.data);
      } catch (error) {
        alert(error.response.data.Exception || "Access denied")
        localStorage.clear();
        navigate("/")
      }
    }
    getOrgUser();
  }, [])

  return user ? (
    user.userRoleName === "BUYER" ? (
      <BuyerDashboard />
    ) 
    : user.userRoleName === "PURCHASE_MANAGER" ? (
      <PurchaseHeadDashboard />
    )
    : <CXODashboard />
  ) : null;
};

export default Dashboard;
